import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

interface MobiSubConfig {
  mobisubUrl: string;
}

interface MobiSimConfig {
  mobisimUrl: string;
}

interface MobiEdocConfig {
  mobiedocUrl: string;
}

interface MobiAdminConfig {
  mobiadminUrl: string;
}

interface WebSsoOidc {
  issuer: string;
  clientId: string;
  redirectUri: string;
  tokenUrl?: string;
  revokeUrl?: string;
  authorityImplies: Record<string, string[]>;
}

interface Config {
  url: string;
  basepath: string;
  urlEff: string;
  mobisub: MobiSubConfig;
  mobisim: MobiSimConfig;
  mobiedoc: MobiEdocConfig;
  mobiadmin: MobiAdminConfig;
  devOrLocal: boolean;
  production: boolean;
  oidcConfig?: WebSsoOidc;
}

export interface IAppConfig {
  url: string;
  basepath: string;
  urlEff: string;
  mobisubUrl: string;
  mobisimUrl: string;
  mobiedocUrl: string;
  mobiadminUrl: string;
  devOrLocal: boolean;
  production: boolean;
  load: () => Observable<Config>;
}

@Injectable()
export class AppConfig implements IAppConfig {
  private readonly http = inject(HttpClient);

  public url = '';
  public basepath = '';
  public urlEff = '';
  public mobisubUrl = '';
  public mobisimUrl = '';
  public mobiedocUrl = '';
  public mobiadminUrl = '';
  public devOrLocal = false;
  public production = false;
  public oidcConfig?: WebSsoOidc;
  public authorityImplies: Record<string, string[]> = {};
  public roles: Record<string, string> = {};

  public load(): Observable<Config> {
    return this.http.get<Config>('./assets/config.json').pipe(
      tap({
        next: (config: Config) => {
          Object.assign(this, config);
          this.url = config?.url ?? '';
          this.basepath = config?.basepath ?? '';
          this.urlEff = config?.urlEff ?? '';
          this.mobisubUrl = config?.mobisub?.mobisubUrl ?? '';
          this.mobisimUrl = config?.mobisim?.mobisimUrl ?? '';
          this.mobiedocUrl = config?.mobiedoc?.mobiedocUrl ?? '';
          this.mobiadminUrl = config?.mobiadmin?.mobiadminUrl ?? '';
          this.devOrLocal = config?.devOrLocal;
          this.production = config?.production;
        },
        error: (err: HttpErrorResponse) => {
          console.log(err.message);
        }
      })
    );
  }
}

export const initConfig =
  (config: AppConfig): (() => Observable<Config>) =>
  () =>
    config.load();
